module.exports = __webpack_public_path__ + "media/images/icons8-shortlist-5372ceb0bf2120be32882c6e98771997.svg";